import { Plus, X } from "lucide-react";
import { useState } from "react";
import { splitTerms } from "@/lib/setup/format";


/** Search terms as chips; storage stays the comma-joined string. */
export function TermChips({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const terms = splitTerms(value);
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState("");
  const commit = () => {
    const t = draft.replace(/,/g, " ").trim();
    if (t && !terms.includes(t)) onChange([...terms, t].join(", "));
    setDraft("");
    setAdding(false);
  };
  return (
    <ul className="flex flex-wrap gap-2" aria-label="Search terms">
      {terms.map((t) => (
        <li key={t} className="inline-flex items-center gap-1 rounded-full border bg-background px-2.5 py-0.5 text-sm">
          {t}
          <button type="button" aria-label={`Remove ${t}`} onClick={() => onChange(terms.filter((x) => x !== t).join(", "))}
            className="text-muted-foreground hover:text-foreground">
            <X aria-hidden className="size-3" />
          </button>
        </li>
      ))}
      <li>
        {adding ? (
          <input
            autoFocus aria-label="New search term" value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === ",") { e.preventDefault(); commit(); }
              if (e.key === "Escape") { setDraft(""); setAdding(false); }
            }}
            onBlur={commit}
            className="h-7 w-40 rounded-full border bg-background px-2.5 text-sm"
          />
        ) : (
          <button type="button" onClick={() => setAdding(true)}
            className="inline-flex items-center gap-1 rounded-full border border-dashed px-2.5 py-0.5 text-sm text-muted-foreground hover:text-foreground">
            <Plus aria-hidden className="size-3" /> term
          </button>
        )}
      </li>
    </ul>
  );
}
